module.exports = __webpack_public_path__ + "static/media/green-check-ic.90e0fa18.svg";